module.exports = __webpack_public_path__ + "static/media/add_location-24px.7763bca8.svg";